import { gql } from '@apollo/client'

export const POSITIONS_TREE_UPDATE_MUTATION = gql`
  mutation POSITIONS_TREE_UPDATE_MUTATION($positions: [PositionsTreeUpdateInput]!) {
    positionsTreeUpdate(positions: $positions) {
      ok
    }
  }
`

export const POSITION_DELETE_MUTATION = gql`
  mutation POSITION_DELETE_MUTATION($id: ID!) {
    positionDelete(id: $id) {
      ok
    }
  }
`

export const POSITION_UPDATE_MUTATION = gql`
  mutation POSITION_UPDATE_MUTATION($id: ID!, $position: PositionUpdateInput!) {
    positionUpdate(id: $id, position: $position) {
      ok
    }
  }
`

export const POSITION_CREATE_MUTATION = gql`
  mutation POSITION_CREATE_MUTATION($position: PositionCreateInput!) {
    positionCreate(position: $position) {
      ok
    }
  }
`

export const POSITIONS_BULK_IMPORT_MUTATION = gql`
  mutation POSITIONS_BULK_IMPORT_MUTATION($input: PositionsBulkImportInput!) {
    positionsBulkImport(input: $input) {
      ok
      message
    }
  }
`
